import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import Alert from './Alert';

import Form from '../../../ui/Form';
import Spinner from '../../../ui/Spinner';
import { AccentButton } from '../../../ui/Button';

import { ActionTypes } from '../../../../store/sngpc/types';

import * as Styles from './FormStyles';

interface Props {
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => any;
  children: React.ReactNode;
  loading: boolean;
  error: string | null;
  step: number;
}

const BaseForm: React.FC<Props> = ({ onSubmit, error, loading, step, children }: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleBack = (): void => {
    dispatch({
      type: ActionTypes.GO_BACK,
    });

    if (step <= 1) {
      history.push('/login');
    }
  };

  const getType = (): 'danger' | 'warning' | 'none' => {
    if (error) return 'danger';

    if (step === 1) return 'warning';

    return 'none';
  };

  return (
    <Styles.FormContainer>
      <Form onSubmit={onSubmit}>
        {children}
        <Alert type={getType()} error={error} />
        <Styles.ActionsContainer>
          <Styles.ButtonBack type="button" onClick={handleBack}>
            Voltar
          </Styles.ButtonBack>
          <AccentButton type="submit" bgColor="primary" width="178px" disabled={loading}>
            {loading ? <Spinner size="18px" /> : 'Continuar'}
          </AccentButton>
        </Styles.ActionsContainer>
      </Form>
    </Styles.FormContainer>
  );
};

export default BaseForm;
